import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import App from '../../components/App/App';
import Overview from '../../components/Overview/Overview';

const OverviewPage = () => {
  return (
    <App>
      <Overview />
    </App>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60 * 60,
});

export default OverviewPage;
